<p-dialog
  header="Error"
  [(visible)]="isVisible"
  [modal]="true"
  [style]="{ width: '600px', minWidth: '200px' }"
  [closable]="false"
  [minY]="100"
  [maximizable]="false"
  [baseZIndex]="10000"
  class="footer"
>
  <div class="footer">
    <div style="margin-right: 20px">
      <img
        src="/assets/images/Error.png"
        alt="Error Image"
        style="
          max-width: 100px;
          height: auto;
          height: 50px;
          padding-bottom: 12px;
        "
      />
    </div>
    <div>
      <div>{{ message }}</div>
      <br />
      <div class="flex justify-content-center gap-2">
        <p-button label="Ok" (click)="close()" />
      </div>
    </div>
  </div>
</p-dialog>
